module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 1024 1024\"><path d=\"M807 631q25-45 38.5-96.5T859 428q0-89-34-167.5T733 124 596.5 32 430-2q-89 0-167.5 34T126 124 34 260.5 0 428t34 167 92 136 136.5 92T430 857q55 0 106.5-13.5T633 805q7-3 35-20.5t33-20.5l257 225 66-66-257-225 19.5-32 20.5-35zM66 428q0-76 28.5-142t78-115T288 93t142-29q75 0 141 29t115.5 78 78 115T793 428q0 75-28.5 141t-78 115.5-115.5 78T430 791q-76 0-142-28.5t-115.5-78-78-115.5T66 428z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/SearchIcon/SearchIcon.svg
 ** module id = 649
 ** module chunks = 0
 **/